module.exports = "/shifts/shift-acceptance/rejectShiftModal-00eb31.html";